import { jsx as _jsx } from "react/jsx-runtime";
import OptionList from './OptionList';
import { getTranslation } from '../translations';
const CompanySelector = ({ companies, environment, loading, error, onSelect, }) => {
    const labels = getTranslation();
    return (_jsx(OptionList, { title: labels.selectCompany, context: `${labels.environment} ${environment}`, loading: loading, error: error, options: companies.map((company) => ({
            id: company.id,
            label: company.name,
            value: company.name,
        })), onSelect: onSelect }));
};
export default CompanySelector;
